import { AfterViewInit, Component, OnDestroy, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';

import { CxSnackbarService } from '@bbraun/cortex/snackbar';
import { OAuthEvent, OAuthService } from 'angular-oauth2-oidc';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { environment } from '../environments/environment';
import { authConfig } from './modules/auth/auth.config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false
})

export class AppComponent implements AfterViewInit, OnDestroy {
  private readonly onDestroy$ = new Subject<void>();

  constructor(
        private readonly oauthService: OAuthService,
        private readonly router: Router,
        private readonly snackbarService: CxSnackbarService,
        private readonly viewContainerRef: ViewContainerRef
  ) {
    this.configure();
  }

  ngAfterViewInit(): void {
    // Cortex 16 requires a host ViewContainerRef for snackbar rendering.
    this.snackbarService.setViewContainerRef(this.viewContainerRef);
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  private configure(): void{
    this.oauthService.configure(authConfig);
    this.oauthService.setupAutomaticSilentRefresh();
    this.loadDiscoveryDocumentAndTryLogin().then(
      () => {
        this.router.initialNavigation();
        this.setupAutomaticLogoutInCaseOfTokenExpiry();
      }
    );
  }

  /**
   * Convenience method that first calls `loadDiscoveryDocument(...)` and
   * directly chains using the `then(...)` part of the promise to call
   * the `tryLogin(...)` method.
   *
   * @param options LoginOptions to pass through to `tryLogin(...)`
   */
  private loadDiscoveryDocumentAndTryLogin(options = null) {
    if (environment.wellKnownUrl && environment.wellKnownUrl.trim()) {
      return this.oauthService.loadDiscoveryDocument(environment.wellKnownUrl).then(doc => {
        return this.oauthService.tryLogin(options);
      });
    } else {
      return this.oauthService.loadDiscoveryDocumentAndTryLogin();
    }
  }

  private setupAutomaticLogoutInCaseOfTokenExpiry(): void {
    if (!this.oauthService.events) {
      return;
    }

    this.oauthService.events
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((event: OAuthEvent) => {
        if (event.type === 'token_expires') {
          this.router.navigateByUrl('login');
        }
      });
  }
}
